module.exports = __webpack_public_path__ + "static/media/dark_i.a91b0659.svg";